/**
 * API endpoint for user actions.
 */
export const ACTIONS_API = "/actions/";

/**
 * Default page size for actions list.
 */
export const ACTIONS_PAGE_SIZE = 20;

/**
 * Action status names (match ActionStatus.name in database).
 */
export const ACTION_STATUS = {
  ACTION_ISSUED: "Action Issued",
  NOT_STARTED: "Not Started",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
} as const;

/**
 * Action type slugs used throughout the application.
 * These correspond to ActionType.slug values in the database.
 */
export const ACTION_TYPE_SLUG = {
  // Program actions
  PROFILE_PARTICIPANT: "profile_participant",
  SCHEDULE: "schedule",
  CIRCLE_VIEW: "circle_view",
  MATCHING_QUIZ: "matching_quiz",
  MEETING_SURVEY: "meeting_survey",
  MEETING: "meeting_attend",
  MEETING_STANDALONE: "meeting_standalone",
  MEETING_READING: "meeting_reading",
  MEETING_SCRIPT: "meeting_script",
  ARTICLE_INFORMATIONAL: "article_informational",
  ORIENTATION_RSVP: "orientation_rsvp",
  CALENDAR_ADD: "calendar_add",
  WORKBOOK_DOWNLOAD: "workbook_download",
  SOCIALMEDIAKIT_DOWNLOAD: "socialmediakit-download",

  // Invitation
  SEND_INVITATION: "send_invitation",

  // Organization
  ORG_MANAGE: "org_manage",

  // Onboarding
  ONBOARDING: "onboarding",

  // Org admin onboarding steps
  ORG_DISPLAY_NAME: "org_display_name",
  ORG_ONBOARDING_QUIZ: "org_onboarding_quiz",
  ORG_UPLOAD_LOGO: "org_upload_logo",
  ORG_UPDATE_SOCIALS: "org_update_socials",

  // Field updates
  UPDATE_TIMEZONE: "update_timezone",
  COLLECT_PHONE_NUMBER: "collect_phone_number",
} as const;

export type ActionTypeSlug =
  (typeof ACTION_TYPE_SLUG)[keyof typeof ACTION_TYPE_SLUG];

/**
 * Action type slugs that represent onboarding flows.
 * A user may have multiple onboarding actions simultaneously (e.g., participant + admin).
 */
export const ONBOARDING_ACTION_TYPES: string[] = [
  ACTION_TYPE_SLUG.ONBOARDING,
];

/**
 * Target object types for actions.
 * These correspond to the target_object_type field values in the database.
 */
export const TARGET_OBJECT_TYPE = {
  ORGANIZATION: "organization",
  QUIZ: "quiz",
  ARTICLE: "article",
  MEETING: "meeting",
  INVITATION: "invitation",
} as const;

export type TargetObjectType =
  (typeof TARGET_OBJECT_TYPE)[keyof typeof TARGET_OBJECT_TYPE];
